/**
 * @generated SignedSource<<77848fb988911d04b1457b870f9b68fb>>
 * @relayHash 7e3d2816177299a18b7cdd237294c9a7
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/441.0.0-2023-12-05T07:13:15.252Z/ShippingDetailsContainerRefetchQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddressResolutionType = "ADDRESS" | "IP" | "%future added value";
export type ShippingDetailsContainerRefetchQuery$variables = {
  addressResolutionType?: AddressResolutionType | null;
  country?: string | null;
  itemId?: string | null;
  itemQuantity?: number | null;
  shouldFetchItemDelivery?: boolean | null;
  shouldFetchTransactionDelivery?: boolean | null;
  transactionId?: string | null;
  userId?: string | null;
  zipCode?: string | null;
};
export type ShippingDetailsContainerRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsQuotesTable_viewer">;
  };
};
export type ShippingDetailsContainerRefetchQuery = {
  response: ShippingDetailsContainerRefetchQuery$data;
  variables: ShippingDetailsContainerRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "IP",
  "kind": "LocalArgument",
  "name": "addressResolutionType"
},
v1 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "country"
},
v2 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "itemId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemQuantity"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldFetchItemDelivery"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldFetchTransactionDelivery"
},
v6 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "transactionId"
},
v7 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v8 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "zipCode"
},
v9 = {
  "kind": "Variable",
  "name": "addressResolutionType",
  "variableName": "addressResolutionType"
},
v10 = {
  "kind": "Variable",
  "name": "country",
  "variableName": "country"
},
v11 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v12 = {
  "kind": "Literal",
  "name": "isCheckout",
  "value": false
},
v13 = {
  "kind": "Variable",
  "name": "quantity",
  "variableName": "itemQuantity"
},
v14 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v15 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "zipCode"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v17 = [
  (v16/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      (v16/*: any*/)
    ],
    "storageKey": null
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ShipmentQuoteEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ShipmentQuote",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLocalPickup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "handlingTimeDisplay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialAmount",
            "kind": "LinkedField",
            "name": "subTotalAmount",
            "plural": false,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialAmount",
            "kind": "LinkedField",
            "name": "buyerTotalAmount",
            "plural": false,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "buyerServiceMethodDisplay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showQuoteAsPending",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCustom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialAmount",
            "kind": "LinkedField",
            "name": "totalAmount",
            "plural": false,
            "selections": [
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ShipmentServiceMethod",
            "kind": "LinkedField",
            "name": "serviceMethod",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceMethodType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "windowMinDays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "windowMaxDays",
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ShippingDetailsContainerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShippingDetailsQuotesTable_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "ShippingDetailsContainerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "showShippingDiscounts",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "subsidizedShippingPDP"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"subsidizedShippingPDP\")"
          },
          {
            "condition": "shouldFetchItemDelivery",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "itemDeliveryOptions",
                "args": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemId"
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "concreteType": "ShipmentQuoteConnection",
                "kind": "LinkedField",
                "name": "availableDeliveryOptions",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "shouldFetchTransactionDelivery",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "transactionDeliveryOptions",
                "args": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "transactionId",
                    "variableName": "transactionId"
                  },
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "concreteType": "ShipmentQuoteConnection",
                "kind": "LinkedField",
                "name": "availableDeliveryOptions",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": null
              }
            ]
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/441.0.0-2023-12-05T07:13:15.252Z/ShippingDetailsContainerRefetchQuery",
    "metadata": {},
    "name": "ShippingDetailsContainerRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b5c7f4523c67872fb94bf287ea9d34bc";

export default node;
